import React from 'react';

import type { RowData } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

import st from './TableViewHead.module.sass';
import type { TableViewHeadProps } from './types';
import { buildTestid } from '../../../lib/utils';

const displayName = 'TableViewHead';
const testid = buildTestid(displayName);

function TableViewHead<TData extends RowData>({
  table,
  className = undefined,
  'data-testid': dataTestId = undefined,
  render = undefined,
  children = undefined,
}: TableViewHeadProps<TData>): React.JSX.Element {
  const $children = children ?? render?.({
    table,
    'data-testid': dataTestId,
  });

  return (
    <div
      className={classNames(st.TableViewHead, className)}
      {...testid(dataTestId)}
    >
      {table.getHeaderGroups().map((headerGroup) => (
        <div
          className={st.TableViewHead__Row}
          {...testid(`TableViewHead_${headerGroup.id}`, dataTestId)}
          key={headerGroup.id}
        >
          {!!$children && $children}
          {!$children && headerGroup.headers.map((header) => (
            <React.Fragment key={header.id}>
              {flexRender(header.column.columnDef.header, header.getContext())}
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
}

TableViewHead.displayName = displayName;

export { TableViewHead };
